import React, { Fragment, useState, useEffect } from 'react';
import { Notification, Card, Table, Title, Modal, Box, Button, Progress, Column } from "rbx";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import AppService from '../../../services/app';
import { payMethods, states, types } from '../../../commons/constants';
import PaginationCustom from '../../components/PaginationCustom';
import { monetaryMask } from '../../../commons/masks';

const AppPurchaseHistoryList = (props) => {
  const { goToMenu } = props;
  const [purchases, setPurchases] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);
  const [activeProgress, setActiveProgress] = useState(true);
  const [activeModal, setActiveModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [status, setStatus] = useState('');

  useEffect(() =>{
    fetchPurchases();
  },[])

  const fetchPurchases = async () => {
    const app = JSON.parse(sessionStorage.getItem('app'));
    try {
      const response = await AppService.purchaseHistory(app.cpf_cnpj);
      setPurchases(response.data.history);
    } catch(e) {
      setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
    }
    setActiveProgress(false);
  }

  const openModal = (index) => {
    setActiveModal(true);
    setSelectedPurchase(index);
  }

  const close = () => setActiveModal(false);

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  const renderModal = () => {
    if (selectedPurchase !== null) {
      const purchase = pageOfItems[selectedPurchase];
      const styleHr = {'background-color': 'transparent', 'border-color': 'rgb(221, 221, 221)', 'border-style': 'dashed', 'border-width': '1px 0px 0px', 'margin': '3px 0'};
      return (
        <Box>
          <Title size={5} className="mb-4">Detalhes da Compra</Title>
          <hr style={ styleHr }/>
          <small><strong>Data da compra</strong></small><br />
          {moment(purchase.date).format('DD/MM/YYYY HH:mm:ss')}
          <hr style={ styleHr }/>
          <small><strong>Quantidade CADs</strong></small><br />
          {purchase.quantity}
          <hr style={ styleHr }/>
          <small><strong>Custo Total</strong></small><br />
          {monetaryMask(purchase.total_cost/100)}
          <hr style={ styleHr }/>
          <small><strong>Forma Pagamento</strong></small><br />
          {payMethods[purchase.payment_method]}
          <hr style={ styleHr }/>
          <small><strong>isRemove</strong></small><br />
          {(purchase.isRemove) ? 'Yes' : 'No'}
          <hr style={ styleHr }/>
          <small><strong>Tipo compra</strong></small><br />
          {types[purchase.type]}
          <hr style={ styleHr }/>
          <small><strong>Situação</strong></small><br />
          {states[purchase.state]}
        </Box>
      )
    }
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Header.Title>Histórico de compras</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Table fullwidth>
            <Table.Head>
              <Table.Row>
                <Table.Heading>Data Compra</Table.Heading>
                <Table.Heading>Quantidade</Table.Heading>
                <Table.Heading>Custo</Table.Heading>
                <Table.Heading>Situação</Table.Heading>
                <Table.Heading></Table.Heading>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {
                (pageOfItems.length === 0)
                  ?
                  <Table.Row key={0}>
                    <Table.Cell colspan="9">
                      { (activeProgress) ? <Progress size='small' color='custom-purple' /> : 'Não há compras para este usuário.' }
                    </Table.Cell>
                  </Table.Row>
                  :
                  pageOfItems.map((purchase, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{moment(purchase.date).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
                      <Table.Cell>{purchase.quantity}</Table.Cell>
                      <Table.Cell>{monetaryMask(purchase.total_cost/100)}</Table.Cell>
                      <Table.Cell>{states[purchase.state]}</Table.Cell>
                      <Table.Cell>
                        <Button key={purchase._id} size="small" color="custom-purple" outlined onClick={() => openModal(index)} title="Detalhe">
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                ))
              }
            </Table.Body>
          </Table>
          <Column.Group breakpoint="mobile">
            <Column className="has-text-left">
              <Link onClick={goToMenu} className="button is-primary">Voltar</Link>
            </Column>
            <Column className="has-text-right">
              <PaginationCustom items={purchases} onChangePage={onChangePage} />
            </Column>
          </Column.Group>
        </Card.Content>
      </Card>

      <Modal closeOnBlur={true} closeOnEsc={true} active={activeModal} onClose={close}>
        <Modal.Background onClick={close} />
        <Modal.Content>
          { renderModal() }
        </Modal.Content>
        <Modal.Close />
      </Modal>
    </Fragment>
  )

}

export default AppPurchaseHistoryList;
